module.exports = __webpack_public_path__ + "static/img/長版LOGO-黑2.png";